import React from 'react';

import { makeStyles } from '@material-ui/core/styles';


const useStyle = makeStyles((theme) => ({
  body: {
    backgroundColor: '#fff',
    borderRadius: 6,
    border: 'solid 1px #dfdfe6',
  },
  item: {
    fontSize: 16,
    fontWeight: 500,
    color: '#5e6784',
  },
  nomeArquivo: {
    fontSize: 16,
    lineHeight: 1.38,
    color: '#061243'
  },
  nomeArquivoHover: {
    fontSize: 16,
    lineHeight: 1.38,
    color: '#044ada'
  },
  arquivoDetalhe: {
    fontSize: 12,
    color: '#5e6784'
  },
  arquivoTamanho: {
    fontSize: 16,
    color: '#5e6784'
  },
  arquivoTamanhoHover: {
    fontSize: 16,
    color: '#044ada'
  },
  content: {
    padding: 12,
    '&:hover': {
      backgroundColor: '#edf4ff',
      color: '#044ada'
    },
    cursor: 'pointer'
  },

}));

export default useStyle;
